<template>
    <section id="home" class="hero_section">
        <h1 class="hero_section_title">Hi, I'm Ifechukwu Nwachukwu</h1>
        <p class="hero_section_text">Mobile and Web Developer | Aspiring Entrepreneur</p>
        <p class="hero_Section_bio">
            I am a resourceful, creative, and results-driven mobile & web developer, writer, and aspiring entrepreneur focused on innovation 
            and problem-solving. With a passion for continuous learning, I leverage my skills to create value, drive success, and 
            turn challenges into growth opportunities.
        </p>
        <div class="hero_section_button">
            <a href="#projects" class="projects_link">View my Work</a>
        </div>
    </section>
</template>

<style scoped>
    .hero_section {
        height: 100vh;
        margin-left: 30px;
        margin-right: 30px;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        /* border-bottom: 3px solid rgb(73, 2, 46, 0.5); */
    }

    .hero_section_title{
        font-size: 54px;
        font-weight: bold;
        font-family: 'Pacifico', cursive;
        color: rgb(244, 187, 222);
        text-align: left;
        width: 80%;
    }

    .hero_section_text{
        font-size: 32px;
        font-weight: 700;
        color: rgb(150, 8, 96);;
        margin-top: 10px;
        text-align: left;
        width: 80%;
    }

    .hero_Section_bio{
        font-size: 24px;
        color: #A5A5A5;
        margin-top: 5px;
        text-align: left;
        width: 80%;
    }

    .hero_section_button{
        width: 80%;
        margin-top: 50px;
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    .projects_link {
        background: rgb(73, 2, 46);
        color: rgb(244, 187, 222);
        padding: 15px;
        border-radius: 10px;
        border: 3px solid black;
        font-weight: 700;
        text-decoration: none;
    }

    .projects_link:hover {
        background: rgb(150, 8, 96);
        border: 3px solid black;
        transition: all 0.3s ease-in-out;
    }

    @media (max-width: 768px) {
        .hero_section_title {
            font-size: 32px;
            font-weight: 700;
            width: 100%;
        }

        .hero_section_text {
            font-size: 24px;
            width: 100%;
        }

        .hero_Section_bio {
            font-size: 18px;
            width: 100%;
            margin-top: 10px;
        }

        .hero_section_button{
            width: 100%;
            margin-top: 30px;
        }
    }
</style>